module.exports = __webpack_public_path__ + "static/media/alexia-logo.08c2a588.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alexia-logo.png
// module id = 1709
// module chunks = 0